import { render, staticRenderFns } from "./Relaties.vue?vue&type=template&id=4f0a4ea3&scoped=true&"
import script from "./Relaties.vue?vue&type=script&lang=js&"
export * from "./Relaties.vue?vue&type=script&lang=js&"
import style0 from "./Relaties.vue?vue&type=style&index=0&id=4f0a4ea3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0a4ea3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VSimpleTable})
